import { render } from "./PlantCard.vue?vue&type=template&id=aada3b7c&ts=true"
import script from "./PlantCard.ts?vue&type=script&lang=ts"
export * from "./PlantCard.ts?vue&type=script&lang=ts"

import "./PlantCard.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__